/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/wheelchair'
export default icon
